import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import './GestionPremio.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { ConfirmDialog } from 'primereact/confirmdialog';

export default function GestionPremio() {
    const [premios, setPremios] = useState([]);
    const [visible, setVisible] = useState(false);
    const [newPremio, setNewPremio] = useState({ id: null, nombre: '', descripcion: '', puntos: 0, id_usuario: null, imagen: null });
    const [editing, setEditing] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [errors, setErrors] = useState({});
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [selectedPremio, setSelectedPremio] = useState(null); // Estado para almacenar el premio seleccionado para eliminación

    useEffect(() => {
        cargarPremios();
        const userId = localStorage.getItem('userId');
        setNewPremio(prevState => ({ ...prevState, id_usuario: userId }));
    }, []);

    const toast = useRef(null);

    const cargarPremios = async () => {
        try {
            const response = await fetch('/api/merito/premio/findall', {
                method: 'GET',
                headers: {
                    'Authorization': 'Basic ' + btoa('admin:querty')
                },
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                setPremios(data);
            } else {
                console.error('Error al cargar premios:', response.statusText);
            }

            const username = localStorage.getItem('username');
            setNewPremio(prevState => ({ ...prevState, id_usuario: username }));
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const agregarPremio = async () => {
        const formData = new FormData();
        formData.append('nombre', newPremio.nombre);
        formData.append('descripcion', newPremio.descripcion);
        formData.append('puntos', newPremio.puntos);
        formData.append('id_usuario', newPremio.id_usuario);

        // Solo agrega la imagen si hay una seleccionada
        if (selectedImage) {
            formData.append('imagen', selectedImage);
        }

        try {
            const response = await fetch('/api/merito/premio/save', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            if (response.ok) {
                cargarPremios();
                setVisible(false);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Premio agregado correctamente' });
            } else {
                console.error('Error al agregar premio:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const actualizarPremio = async () => {
        try {
            const formData = new FormData();
            formData.append("nombre", newPremio.nombre);
            formData.append("descripcion", newPremio.descripcion);
            formData.append("puntos", newPremio.puntos);
            formData.append("id_usuario", newPremio.id_usuario);

            if (newPremio.imagen) {  // Asegúrate de que newPremio.imagen sea un archivo
                formData.append("imagen", newPremio.imagen);
            }

            const response = await fetch(`/api/merito/premio/updatebyid/${newPremio.id}`, {
                method: 'PUT',
                body: formData,
                credentials: 'include'
            });

            if (response.ok) {
                cargarPremios();
                setVisible(false);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Premio actualizado correctamente' });
            } else {
                console.error('Error al actualizar premio:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };


    const eliminarPremio = async (id) => {
        try {
            const response = await fetch(`/api/merito/premio/deletebyid/${id}`, {
                method: 'DELETE',
                credentials: 'include'
            });

            if (response.ok) {
                setConfirmationVisible(false); // Ocultar el cuadro de diálogo de confirmación
                cargarPremios();
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Premio eliminado correctamente' });
            } else {
                console.error('Error al eliminar premio:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const handleAgregarPremio = () => {
        const username = localStorage.getItem('username');
        setNewPremio({ id: null, nombre: '', descripcion: '', puntos: 0, id_usuario: username, imagen: null });
        setPreviewImage(null);  // Reset preview image when adding a new premio
        setSelectedImage(null); // Reset selected image when adding a new premio
        setVisible(true);
        setEditing(false); // Ensure the dialog is set to "Agregar" mode
    };

    const handleInputChange = (e, key) => {
        const value = e.target.value;
        setNewPremio(prevState => ({
            ...prevState,
            [key]: value
        }));

        // Validar campo puntos
        if (key === 'puntos' && !value) {
            setErrors(prevErrors => ({
                ...prevErrors,
                puntos: "Puntos Requeridos es obligatorio"
            }));
        } else if (key === 'puntos') {
            setErrors(prevErrors => {
                const { puntos, ...restErrors } = prevErrors;
                return restErrors;
            });
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setSelectedImage(file);

        // Generate a URL for the image preview
        const reader = new FileReader();
        reader.onloadend = () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
                if (img.width > 300 || img.height > 180) {
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        imagen: 'La imagen debe ser de 300(Ancho) x 180(Altura) o menos'
                    }));
                    setSelectedImage(null);
                    setPreviewImage(null);
                } else {
                    setErrors(prevErrors => {
                        const { imagen, ...restErrors } = prevErrors;
                        return restErrors;
                    });
                    setPreviewImage(reader.result);
                }
            };
        };
        reader.readAsDataURL(file);
    };

    const editarPremio = (premio) => {
        setNewPremio({
            id: premio.id,
            nombre: premio.nombre,
            descripcion: premio.descripcion,
            puntos: premio.puntos,
            id_usuario: premio.id_usuario,
            imagen: premio.imagen
        });
        setPreviewImage(premio.imagen);  // Set the preview image for editing
        setVisible(true);
        setEditing(true);
    };

    const handleAgregarEditar = () => {
        let validationErrors = {};

        if (!newPremio.puntos) {
            validationErrors.puntos = "* Es obligatorio ingresar la cantidad de Puntos Requeridos";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        if (editing) {
            actualizarPremio();
        } else {
            agregarPremio();
        }
        setErrors({});
    };

    const renderToast = () => (
        <Toast ref={toast} />
    );

    const confirmarEliminacion = () => {
        eliminarPremio(selectedPremio.id);
        setConfirmationVisible(false);
    };

    return (
        <div className="p-grid p-fluid">
            {renderToast()}
            <div className="p-col-12">
                <Dialog visible={visible} style={{ width: '450px' }} header={editing ? "Editar Premio" : "Agregar Premio"} onHide={() => setVisible(false)} modal>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <label htmlFor="nombre">Nombre:</label>
                            <InputText id="nombre" value={newPremio.nombre} onChange={(e) => handleInputChange(e, 'nombre')} />
                        </div>
                        <div className="p-col-12">
                            <label htmlFor="descripcion">Descripción:</label>
                            <InputText id="descripcion" value={newPremio.descripcion} onChange={(e) => handleInputChange(e, 'descripcion')} />
                        </div>
                        <div className="p-col-12">
                            <label htmlFor="puntos">Puntos Requeridos:</label>
                            <InputNumber id="puntos" value={newPremio.puntos} onValueChange={(e) => handleInputChange(e, 'puntos')} />
                            {errors.puntos && <small className="p-error">{errors.puntos}</small>}
                        </div>
                        <div className="p-col-12" style={{ marginBottom: '20px' }}>
                            {previewImage && (
                                <img src={previewImage} alt="Preview" style={{ width: '100%' }} />
                            )}
                        </div>
                        <div className="p-col-12" style={{ marginBottom: '20px' }}>
                            <div className="file-input-wrapper">
                                <label htmlFor="imagen" className="file-input-label">
                                    <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                    Subir Imagen
                                </label>
                                <input type="file" id="imagen" className="file-input" onChange={handleImageChange} />
                            </div>
                            {errors.imagen && <small className="p-error">{errors.imagen}</small>}
                        </div>

                        <div className="p-col-12 p-d-flex p-jc-between">
                            <Button label="Cancelar" className="p-button-raised p-button-text" onClick={() => setVisible(false)} />
                            <Button label={editing ? 'Guardar' : 'Agregar'} className="p-button-raised" onClick={handleAgregarEditar} autoFocus />
                        </div>
                    </div>
                </Dialog>
            </div>
            <div className="button-container" style={{ textAlign: 'left' }}>
                <Button label="Añadir Premio" className="p-button-raised p-button-success p-button-sm" icon="pi pi-plus" style={{ width: 'auto' }} onClick={handleAgregarPremio} />
            </div>

            <div className="p-col-12 p-grid-view">
                {premios.map((premio, index) => (
                    <div key={index} className="product-item">
                        <div className="product-detail">
                            <div className="product-name">Nombre: {premio.nombre}</div>
                            <div className="product-description">Descripción: {premio.descripcion}</div>
                            <div className="product-puntos">Puntos Requeridos: {premio.puntos}</div>
                            {premio.imagen && <img src={premio.imagen} alt={premio.nombre} className="product-image" />}
                        </div>
                        <div className="product-buttons">
                            {/* <Button label="Editar" className="p-button-raised p-button-success" onClick={() => editarPremio(premio)} /> */}
                            <Button label="Eliminar" className="p-button-raised p-button-danger" onClick={() => { setSelectedPremio(premio); setConfirmationVisible(true); }} />
                            <ConfirmDialog visible={confirmationVisible} onHide={() => setConfirmationVisible(false)} message="¿Estás seguro de que deseas eliminar este premio?" header="Confirmación" icon="pi pi-exclamation-triangle" acceptClassName="p-button-secondary custom-confirm-button" rejectClassName="p-button-secondary custom-confirm-button" accept={confirmarEliminacion} rejectLabel="No" acceptLabel="Sí" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
